import { render, staticRenderFns } from "./UsuariosLista.vue?vue&type=template&id=3ae2aba2&scoped=true&"
import script from "./UsuariosLista.vue?vue&type=script&lang=js&"
export * from "./UsuariosLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae2aba2",
  null
  
)

export default component.exports